const keys = {
  house: 'house',
  communications: 'communications',
  transport: 'transport',
  personal: 'personal',
  eatout: 'eatout',
  holiday: 'holiday',
  food: 'food',
  leisure: 'leisure',
  health: 'health',
}

const config = {
  questionAnswerData: {
    cohabitingQuestion: {
      question: 'Will you be living with a partner?',
      answers: {
        A: 'On my own.',
        B: 'With a partner.'
      },
      images: {
        Q1AA: 'Q1-AA-bussq.jpg',
        Q1AB: 'Q1-AB-bussq.jpg',
      }
    },
    single: {
      [keys.house]: {
        question: 'How will you budget to maintain your home?',
        answers: {
          A: 'Only enough for basic repairs and maintenance.',
          B: 'A moderate amount for repairs and updated furnishings.',
          C: 'I expect to be able to redecorate and renovate.',
        },
        images: {
          Q2AC: 'Q2-AC.jpg',
          Q2AB: 'Q2-AB-bussq.jpg',
          Q2AA: 'Q2-AA.jpg',
        }
      },
      [keys.communications]: {
        question: "How would you describe your internet, mobile, and streaming service needs?",
        answers: {
          A: "Basic plan with limited data.",
          B: "Standard plan with moderate data and one streaming subscription.",
          C: "High-speed plan with unlimited data and multiple subscriptions.",
        },
        images: {
          Q3AA: 'Q3-AA-bussq.jpg',
          Q3AB: 'Q3-AB-bussq.jpg',
          Q3AC: 'Q3-AC.jpg',
        }
      },
      [keys.food]: {
        question: 'Where will you buy your groceries?',
        answers: {
          A: 'Basic groceries from a local discount supermarket.',
          B: 'Premium groceries from a mainstream supermarket.',
          C: 'Organic, local produce from specialty stores.',
        },
        images: {
          Q4AA: 'Q4-AA.jpg',
          Q4AB: 'Q4-AB.jpg',
          Q4AC: 'Q4-AC.jpg',
        }
      },
      [keys.eatout]: {
        question: "How often will you dine at restaurants or order take-out?",
        answers: {
          A: 'Occasionally for take-out or local club dining.',
          B: 'Every other week for reasonably priced meals and take-out.',
          C: 'Most weeks for quality restaurant dining.',
        },
        images: {
          Q5AA: 'Q5-AA-bussq.jpg',
          Q5AB: 'Q5-AB.jpg',
          Q5AC: 'Q5-AC.jpg',
        }
      },
      [keys.transport]: {
        question: 'How will you get around?',
        answers: {
          A: "Public transport.",
          B: "Basic car.",
          C: "Mid-range car.",
        },
        images: {
          Q6AA: 'Q6-AA.jpg',
          Q6AB: 'Q6-AB-bussq.jpg',
          Q6AC: 'Q6-AC-bussq.jpg',
        }
      },
      [keys.holiday]: {
        question: 'What are your travel plans?',
        answers: {
          A: 'Local travel or occasional day trips.',
          B: 'Occasional interstate trip or a few short breaks.',
          C: 'Annual interstate travel and overseas travel every few years.',
        },
        images: {
          Q7AA: 'Q7-AA-bussq.jpg',
          Q7AB: 'Q7-AB-bussq.jpg',
          Q7AC: 'Q7-AC.jpg',
        }
      },
      [keys.leisure]: {
        question: "How will you typically spend your leisure time?",
        answers: {
          A: 'A relaxing day at the beach.',
          B: 'A trip to the cinema.',
          C: 'A concert or event.',
        },
        images: {
          Q8AA: 'Q8-AA.jpg',
          Q8AB: 'Q8-AB-bussq.jpg',
          Q8AC: 'Q8-AC-bussq.jpg',
        }
      },
      [keys.personal]: {
        question: 'How much will you spend on clothes and self-care?',
        answers: {
          A: "Low maintenance, minimal spending.",
          B: "Treat myself within my budget.",
          C: "Occasional splurges on clothes and self-care.",
        },
        images: {
          Q9AA: 'Q9-AA.jpg',
          Q9AB: 'Q9-AB-bussq.jpg',
          Q9AC: 'Q9-AC.jpg',
        }
      },
      [keys.health]: {
        question: "How will you manage your healthcare needs?",
        answers: {
          A: 'Public health system.',
          B: 'Basic private health insurance.',
          C: 'Comprehensive private health insurance.',
        },
        images: {
          Q10AA: 'Q10-AA-bussq.jpg',
          Q10AB: 'Q10-AB-bussq.jpg',
          Q10AC: 'Q10-AC.jpg',
        }
      },
    },
    // uncomment and populate below if we ever add different question/answer copy. Will also need to update config/index.js getQuestionAnswerData getter
    // cohabiting: {
    //   [keys.house]: {},
    //   [keys.transport]: {},
    //   [keys.personal]: {},
    //   [keys.eatout]: {},
    //   [keys.holiday]: {},
    //   [keys.food]: {},
    //   [keys.treat]: {},
    // }
  },
  currencySymbol: '$',
  inputs: {
    age: {
      min: 18,
      max: 100,
      currentValue: 20, // initial value
    },
    retirementAge: {
      min: 50,
      max: 100,
      currentValue: 70, //initial value
    },
    currentBalance: {
      min: 0,
      max: 1000000,
      currentValue: 0,  //initial value
    },
  },
  engine: {
    interestRate: 0.04,
    statePension: 9627.80,
    annuityRate: 20,
  }
};

export default config;
